export function playIntroCue() {
  // Keep intro quiet; CT clip is rare win spice only.
}

export function playHoverBlip() {
  // No tacky arcade hover bleeps.
}

export function playWinCue(_side: 'left' | 'right') {
  // Win clip handled separately so it can be randomized.
}

export function playInfoCue() {
  // No info bleeps.
}

export function playVersusCue() {
  // Prefer the local bumper; fall back to the original drop-in if present.
  playSequence(['/sounds/versus.mp3', '/sounds/versus.wav', '/sounds/versus-original.mp3'], 0.92);
}

export function playWinnerAssetCue() {
  const clip = Math.random() < 0.52 ? '/sounds/wins_short.mp3' : '/sounds/wins_panatela.mp3';
  playAsset(clip, 0.82);
}

function playSequence(srcs: string[], volume = 0.8) {
  const audio = new Audio();
  audio.volume = volume;
  const tryNext = (index: number) => {
    if (index >= srcs.length) return;
    audio.src = srcs[index];
    audio.currentTime = 0;
    audio.play().catch(() => tryNext(index + 1));
  };
  tryNext(0);
}

function playAsset(src: string, volume = 0.8) {
  const audio = new Audio(src);
  audio.volume = volume;
  void audio.play().catch(() => undefined);
}
